import { z } from 'zod';

/** Papel do membro dentro de um escritório (do maior para o menor poder). */
export const PapelMembro = z.enum(['ADMIN', 'SUPERVISOR', 'OPERADOR', 'LEITOR']);
export type PapelMembro = z.infer<typeof PapelMembro>;
export const ORDEM_PAPEL: Record<PapelMembro, number> = { ADMIN: 4, SUPERVISOR: 3, OPERADOR: 2, LEITOR: 1 };
export function papelAtende(papel: PapelMembro, minimo: PapelMembro): boolean {
  return ORDEM_PAPEL[papel] >= ORDEM_PAPEL[minimo];
}

export const RegimeTributario = z.enum(['SIMPLES', 'MEI', 'PRESUMIDO', 'REAL', 'IMUNE_ISENTA', 'PF']);
export type RegimeTributario = z.infer<typeof RegimeTributario>;

export const SituacaoCliente = z.enum(['ATIVA', 'SUSPENSA', 'BAIXADA']);
export type SituacaoCliente = z.infer<typeof SituacaoCliente>;

export const Esfera = z.enum(['FEDERAL', 'ESTADUAL', 'MUNICIPAL', 'INTERNA']);
export type Esfera = z.infer<typeof Esfera>;

export const GatilhoObrigacao = z.enum(['RECORRENTE', 'ABERTURA', 'ENCERRAMENTO', 'EVENTO']);
export type GatilhoObrigacao = z.infer<typeof GatilhoObrigacao>;

export const RequerEntrega = z.enum(['NENHUMA', 'PROTOCOLO', 'GUIA', 'PROTOCOLO_E_GUIA']);
export type RequerEntrega = z.infer<typeof RequerEntrega>;

// ---- motor de prazos ----
export const Periodicidade = z.enum(['MENSAL', 'TRIMESTRAL', 'QUADRIMESTRAL', 'SEMESTRAL', 'ANUAL', 'EVENTUAL']);
export type Periodicidade = z.infer<typeof Periodicidade>;

export const AncoraBase = z.enum(['FIM_COMPETENCIA', 'INICIO_COMPETENCIA', 'DATA_FIXA_ANUAL', 'EVENTO']);
export type AncoraBase = z.infer<typeof AncoraBase>;

export const ModoDia = z.enum(['DIA_DO_MES', 'ULTIMO_DIA_DO_MES', 'N_ESIMO_DIA_UTIL', 'N_ESIMO_DIA_UTIL_REGRESSIVO', 'OFFSET_DIAS']);
export type ModoDia = z.infer<typeof ModoDia>;

export const UnidadeOffset = z.enum(['CORRIDOS', 'UTEIS']);
export type UnidadeOffset = z.infer<typeof UnidadeOffset>;

export const AjusteNaoUtil = z.enum(['POSTERGAR', 'ANTECIPAR', 'NENHUM']);
export type AjusteNaoUtil = z.infer<typeof AjusteNaoUtil>;

export const ClampDiaInvalido = z.enum(['ULTIMO_DIA_DO_MES', 'ERRO']);
export type ClampDiaInvalido = z.infer<typeof ClampDiaInvalido>;

export const FonteDia = z.enum(['REGRA', 'PARAMETRO_VINCULO']);
export type FonteDia = z.infer<typeof FonteDia>;

export const EscopoCalendario = z.enum([
  'NACIONAL', 'BANCARIO_NACIONAL', 'UF_DO_CLIENTE', 'UF_FIXA', 'MUNICIPIO_DO_CLIENTE', 'MUNICIPIO_FIXO',
]);
export type EscopoCalendario = z.infer<typeof EscopoCalendario>;

export const EscopoFeriado = z.enum(['NACIONAL', 'BANCARIO', 'UF', 'MUNICIPIO']);
export type EscopoFeriado = z.infer<typeof EscopoFeriado>;

// ---- tarefa ----
export const TarefaStatus = z.enum([
  'PENDENTE', 'EM_ANDAMENTO', 'AGUARDANDO_TERCEIRO', 'EM_REVISAO', 'CONCLUIDA', 'DISPENSADA', 'CANCELADA',
]);
export type TarefaStatus = z.infer<typeof TarefaStatus>;
export const STATUS_ABERTOS: readonly TarefaStatus[] = ['PENDENTE', 'EM_ANDAMENTO', 'AGUARDANDO_TERCEIRO', 'EM_REVISAO'];
export const STATUS_TERMINAIS: readonly TarefaStatus[] = ['CONCLUIDA', 'DISPENSADA', 'CANCELADA'];

export const MotivoEspera = z.enum(['CLIENTE', 'DOCUMENTO', 'GOVERNO', 'INTERNO']);
export type MotivoEspera = z.infer<typeof MotivoEspera>;

export const MotivoDispensa = z.enum([
  'SEM_MOVIMENTO', 'NAO_APLICAVEL', 'ENTREGUE_PELO_CLIENTE', 'ENTREGA_CENTRALIZADA', 'FORA_DE_ESCOPO', 'OUTRO',
]);
export type MotivoDispensa = z.infer<typeof MotivoDispensa>;

export const SituacaoRegistro = z.enum(['ATIVA', 'CANCELADA_SEM_EFEITO', 'ARQUIVADA']);
export type SituacaoRegistro = z.infer<typeof SituacaoRegistro>;

export const TipoEntrega = z.enum(['DECLARACAO', 'GUIA', 'DOCUMENTO']);
export type TipoEntrega = z.infer<typeof TipoEntrega>;

export const UFS = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'] as const;
export const UF = z.enum(UFS);
export type UF = z.infer<typeof UF>;
